import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { ClampText } from '../../../../../clamp-text/clamp-text';
import styles from './description.scss';
export const CardDescription = ({ text, withSeparator, isShrinkable, liveLabel, }) => (React.createElement("div", { className: classnames(styles.container, {
        [styles['with-separator']]: withSeparator,
        [styles['is-shrinkable']]: isShrinkable,
        [styles['with-live-label']]: Boolean(liveLabel),
    }) },
    liveLabel && React.createElement("span", { className: styles.live }, liveLabel),
    React.createElement(ClampText, { text: text, dataHook: "action-card-title" })));
CardDescription.propTypes = {
    text: PropTypes.string,
    withSeparator: PropTypes.bool,
    isShrinkable: PropTypes.bool,
    liveLabel: PropTypes.string,
};
//# sourceMappingURL=description.js.map